import { useEffect, useState, useMemo } from "react"
import { AuthService, ErrorConstant, StatusService, StatusType } from "utility"

export const GetStatusList = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const companyId = AuthService.getUser()?.Companies?.[0]?.CompanyId
        ?? AuthService.getUser()?.CompanyId

    const options = useMemo(() => {
        const list = Array.isArray(data) ? data : []
        const mapped = list.map(ele => ({
            value: ele.StatusId,
            text: ele.Status,
        }))
        const isWkCompany = Number(companyId) === 34930
        if (
            isWkCompany &&
            !mapped.some(
                opt =>
                    Number(opt.value) === StatusType.Down ||
                    String(opt.text || '').toLowerCase() === 'down',
            )
        ) {
            mapped.push({ value: StatusType.Down, text: 'Down' })
        }
        return mapped
    }, [data, companyId])

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const result = await StatusService.list()
                setData(Array.isArray(result) ? result : result || [])
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        fetchData()
    }, [])

    return {
        data,
        loading,
        options,
        error,
        setData,
    }
}